import { Enums } from '../../../models/common/enums'
import { IUserSession } from '../../../helpers/user-session'

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ActionsDetailsDirectiveController } from './actions-details.directive.controller'

//#region Asset Imports

import './actions-details.scss'
import * as TEMPLATE from './actions-details.tpl.html'

//#endregion

export class ActionsDetailsDirective implements ng.IDirective {
    restrict = 'E'
    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary', 'userSession',
        ($scope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: IUserSession) => {
            return new ActionsDetailsDirectiveController($scope, $q, $timeout, api, logger, localDictionary, userSession, Enums.ReferenceType.IdAction)
        }]
    template = TEMPLATE
}